import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import RewindJob from '../../types/api/rewind-job'
import { DistributeRewindJobArgs } from '../../types/api/rewind-jobs/distribute-rewind-job'
import { RewindJobCopiesUpdate } from '../../types/api/rewind-jobs/update-rewind-jobs-copies'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const rewindJobsApi = createApi({
    reducerPath: 'rewindJobsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['RewindJobs'],
    endpoints: builder => ({
        getRewindJobs: builder.query<Strapi<RewindJob>, EndpointQueryParameters | void>({
            query: getQuery('/rewind-jobs'),
            providesTags: ['RewindJobs'],
        }),
        createRewindJob: builder.mutation<StrapiSingle<RewindJob>, StrapiCreate<RewindJob>>({
            query: body => ({
                url: '/rewind-jobs',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['RewindJobs'],
        }),
        updateRewindJob: builder.mutation<StrapiSingle<RewindJob>, StrapiUpdate<RewindJob>>({
            query: ({ docId, body }) => ({
                url: `/rewind-jobs/${docId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['RewindJobs'],
        }),
        distributeRewindJob: builder.mutation<Strapi<RewindJob>, DistributeRewindJobArgs>({
            query: ({ docId, machines }) => ({
                url: `/rewind-jobs/${docId}/distribute`,
                method: 'POST',
                body: { data: { machines } },
            }),
            invalidatesTags: ['RewindJobs'],
        }),
        updateRewindJobsCopies: builder.mutation<unknown, RewindJobCopiesUpdate[]>({
            query: data => ({
                url: '/rewind-jobs/copies',
                method: 'PUT',
                body: { data },
            }),
            invalidatesTags: ['RewindJobs'],
        }),
    }),
})

export const {
    useGetRewindJobsQuery,
    useCreateRewindJobMutation,
    useUpdateRewindJobMutation,
    useDistributeRewindJobMutation,
    useUpdateRewindJobsCopiesMutation,
} = rewindJobsApi
